import { Type } from "class-transformer";
import { CommentOutDTO } from "./comment.out.dto";

export class CommentPaginatedOutDTO {
  @Type(() => CommentOutDTO)
  comments!: CommentOutDTO[];

  total!: number;
}
